import delayStore from './store'

export default class DelayModule {
  name = 'delay'
  constructor({ store }) {
    store.registerModule(this.name, delayStore)
  }
}
